import { render, staticRenderFns } from "./AdminClientsMenu.vue?vue&type=template&id=06217729"
import script from "./AdminClientsMenu.vue?vue&type=script&lang=js"
export * from "./AdminClientsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports